import locale from "./buildContentUploadActionsMenuItems.locale";
export default (folder, canEditDocuments, onOpenFolderEditorPanel, onDeleteFolder) => {
    const result = [];
    if (canEditDocuments) {
        result.push({
            icon: "icon-edit font-h5 text-default",
            textClassName: "text-default",
            text: locale.EDIT_FOLDER,
            onClick: () => {
                onOpenFolderEditorPanel && onOpenFolderEditorPanel(folder.Id);
            }
        });
        result.push({
            icon: "icon-trash font-h5 text-red",
            textClassName: "text-red",
            text: locale.DELETE_FOLDER,
            confirm: {
                title: locale.CONFIRM_DELETE_FOLDER_TEXT,
                header: locale.CONFIRM_DELETE_FOLDER_HEADER,
                callback: () => {
                    onDeleteFolder && onDeleteFolder(folder.Id, folder.DocumentId);
                }
            }
        });
    }
    return result;
};
